import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  subHeading: {
    color: theme.palette.text.secondary,
    fontSize: '18px',
    fontWeight: 600,
    marginRight: theme.spacing(1.125),
  },
  infoIcon: {
    color: theme.palette.icon.main,
    marginTop: theme.spacing(0.75),
    '&.MuiSvgIcon-root': {
      height: '16px',
      width: '16px',
    },
  },
  subHeadingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  companyDetailSubHead: {
    marginBottom: theme.spacing(2),
  },
  planSectionRowContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  },

  descriptionTitle: {
    fontSize: '12px',
    color: theme.palette.text.secondary,
  },
  description: {
    fontSize: '16px',
    color: theme.palette.textField.dark,
    margin: `${theme.spacing(0.25, 0)} !important`,
  },
  selectField: {
    '& .MuiInputBase-input': {
      fontSize: '13px',
      color: theme.palette.black.main,
      textAlign: 'left',
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
    },
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: theme.palette.requiredAsterisk.main,
    },
  },
  inputLabel: {
    '&.MuiFormLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
  },
  menuRoot: {
    '&.MuiMenuItem-root': {
      fontSize: '13px',
      color: theme.palette.headerTitle.main,
    },
    '&.MuiListItem-gutters': {
      padding: theme.spacing(1.5),
    },
    '&.MuiListItem-root.Mui-selected': {
      backgroundColor: theme.palette.selectionBackgroundColor.main,
    },
    '&.MuiListItem-button:hover': {
      backgroundColor: theme.palette.selectionBackgroundColor.main,
    },
  },
  icon: {
    '&.MuiSelect-icon': {
      color: theme.palette.text.tertiary,
    },
  },
  formWidth: {
    width: '100%',
    minWidth: '135px',
  },
  marginTop: {
    marginTop: theme.spacing(7),
  },
  marginTopTcv: {
    marginTop: theme.spacing(5),
  },
  feildWidth: {
    width: '317.33px !important',
  },
  tcvLowerContainer: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    color: theme.palette.textField.dark,
  },
  subheadingInfoText: {
    fontSize: '14px',
    fontWeight: 400,
    fontStyle: 'normal',
    lineHeight: '22px',
    color: theme.palette.labraText.description,
  },
  descriptionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  metricDiscount: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  metricDiscountText: {
    marginBottom: '-3px',
  },
  tableHead: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.palette.labraText.description,
    backgroundColor: theme.palette.bgPrimary.main,
    boxShadow: `0px -1px 0px 0px ${theme.palette.dividerV2.main} inset`,
    borderBottom: 'none',
    '&.MuiTableCell-root': {
      padding: theme.spacing(2),
      lineHeight: '1.5rem',
    },
    '&.MuiTableCell-root .MuiFormControlLabel-root': {
      margin: `${theme.spacing(0)} !important`,
    },
  },
  installmentMetricRow: {
    margin: theme.spacing(3, 0),
  },
  shrink: {
    transform: 'translate(0px, -2px) scale(0.75)',
  },
}))
